import React from "react";
import MyPageSideBarItem from "./MyPageSideBarItem";
import styles from "./MyPageSideBar.module.scss";
import { IconLogoutSVG } from "../../../assets/img/IconLogoutSVG";
import { useAppSelector } from "../../../redux/hooks";
import { getNotificationsTotal } from "../../../redux/reducers/chat";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  settings: Array<{
    link: string;
    title: string;
    icon: any;
    description: string;
  }>;
  logoutHandler: () => void;
  showJikeiAdmin: boolean;
  showAdmin: boolean;
};

const MyPageSideBar: React.FC<Props> = ({
  settings,
  logoutHandler,
  showJikeiAdmin,
  showAdmin,
}) => {
  const notifications = useAppSelector(getNotificationsTotal);
  return (
    <>
      <SonicLink to="/mypage" className={styles["g-mypagesidebar__link--top"]}>
        マイページ
      </SonicLink>
      <div className={styles["g-mypagesidebar-ttl"]}>SETTING / EDIT</div>
      <ul className={styles["g-mypagesidebar__nav"]}>
        {settings.map((item, i) => (
          <MyPageSideBarItem
            key={i}
            {...item}
            showNotification={notifications > 0 && item.title === "チャット"}
          />
        ))}

        <li className={styles["g-mypagesidebar__nav-item"]}>
          <button
            type="button"
            className={styles["g-mypagesidebar__nav-link"]}
            onClick={() => logoutHandler()}
          >
            <div className={styles["g-mypagesidebar__nav-icon"]}>
              <IconLogoutSVG width={36.304} height={29.473} />
            </div>
            <div className={styles["g-mypagesidebar__nav-text"]}>
              ログアウト
            </div>
          </button>
        </li>

        {showJikeiAdmin ? (
          <li className={styles["g-mypagesidebar__nav-item"]}>
            <SonicLink
              to="/jikei"
              className={`${styles["g-mypagesidebar__nav-link"]} ${styles["g-mypagesidebar__nav-link-kanri"]}`}
            >
              <div className={styles["g-mypagesidebar__nav-text"]}>
                管理画面へ
              </div>
            </SonicLink>
          </li>
        ) : null}
        {showAdmin ? (
          <li className={styles["g-mypagesidebar__nav-item"]}>
            <SonicLink
              to="/admin"
              className={`${styles["g-mypagesidebar__nav-link"]} ${styles["g-mypagesidebar__nav-link-kanri"]}`}
            >
              <div className={styles["g-mypagesidebar__nav-text"]}>
                SELeCT管理画面へ
              </div>
            </SonicLink>
          </li>
        ) : null}
      </ul>
    </>
  );
};

export default MyPageSideBar;
